import React from 'react';
import { Box, Drawer, Typography } from '@metarouter-private/mr-mui';
import { useDrawerContext } from 'app/shared/contexts/drawer';
import DrawerHeader from 'app/shared/components/drawer/DrawerHeader';
import { TRANSFORMATION_LIB_DRAWER } from './drawers';
import useDrawerCodeEditorProps from './useDrawerCodeEditorProps';
import { AceCodeEditor } from '@ion/components';

function TransformationLibDrawer() {
  const {
    drawer: { isOpen, onClose, data },
  } = useDrawerContext();

  const drawerCodeEditorProps = useDrawerCodeEditorProps();

  return (
    <Drawer anchor="right" data-test-id="transformation-lib-drawer" width="70%" onClose={onClose} open={isOpen}>
      {isOpen && (
        <Box component="section" p={2}>
          <DrawerHeader onClose={onClose}>
            <Typography variant="h6" component="h2">
              Module Name: {data.transformModuleName}
            </Typography>
          </DrawerHeader>
          {data.drawer === TRANSFORMATION_LIB_DRAWER && (
            <Box mt={2}>
              <AceCodeEditor {...drawerCodeEditorProps} value={data.transformModuleBody} />
            </Box>
          )}
        </Box>
      )}
    </Drawer>
  );
}

export default TransformationLibDrawer;
